const formatDistance = (meters: number): string => {
    const km = meters / 1000;

    // we want to display a comma as digits/decimal separator
    return km.toLocaleString('fr-FR', { minimumFractionDigits: 3 });
};

export { formatDistance };
